export default {
  list: [
    {
      title: 'پرداخت نشده',
      value: 'UNPAID',
    },
    {
      title: 'در انتظار',
      value: 'WAITING',
    },
    {
      title: 'تایید شده',
      value: 'APPROVED',
    },
    {
      title: 'تایید شده خودکار',
      value: 'AUTO_APPROVED',
    },
    {
      title: 'شروع شده',
      value: 'STARTED',
    },
    {
      title: 'رد شده',
      value: 'REJECTED',
    },
    {
      title: 'انصراف',
      value: 'CANCELED',
    },
    {
      title: 'عدم مراجعه',
      value: 'CLIENT_DO_NOT_CAME',
    },
    {
      title: 'پایان‌ یافته',
      value: 'FINISHED',
    },
    {
      title: 'تسویه شده',
      value: 'CHECKOUT',
    },
    {
      title: 'زمان سپری شده',
      value: 'TIME_ELAPSED',
    },
  ],
  values: {
    UNPAID: 'UNPAID',
    WAITING: 'WAITING',
    APPROVED: 'APPROVED',
    AUTO_APPROVED: 'AUTO_APPROVED',
    STARTED: 'STARTED',
    REJECTED: 'REJECTED',
    CANCELED: 'CANCELED',
    CLIENT_DO_NOT_CAME: 'CLIENT_DO_NOT_CAME',
    FINISHED: 'FINISHED',
    CHECKOUT: 'CHECKOUT',
  },
};
